var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPending = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68031 1.19984C4.68031 1.00102 4.84149 0.839844 5.04031 0.839844H6.96031C7.15913 0.839844 7.32031 1.00102 7.32031 1.19984C7.32031 1.39867 7.15913 1.55984 6.96031 1.55984H5.04031C4.84149 1.55984 4.68031 1.39867 4.68031 1.19984ZM6.00031 2.51984C3.81326 2.51984 2.04031 4.2928 2.04031 6.47984C2.04031 8.66689 3.81326 10.4398 6.00031 10.4398C8.18736 10.4398 9.96031 8.66689 9.96031 6.47984C9.96031 4.2928 8.18736 2.51984 6.00031 2.51984ZM1.32031 6.47984C1.32031 3.89515 3.41562 1.79984 6.00031 1.79984C8.58501 1.79984 10.6803 3.89515 10.6803 6.47984C10.6803 9.06454 8.58501 11.1598 6.00031 11.1598C3.41562 11.1598 1.32031 9.06454 1.32031 6.47984ZM6.00031 4.19984C6.19913 4.19984 6.36031 4.36102 6.36031 4.55984V6.47984C6.36031 6.67867 6.19913 6.83984 6.00031 6.83984C5.80149 6.83984 5.64031 6.67867 5.64031 6.47984V4.55984C5.64031 4.36102 5.80149 4.19984 6.00031 4.19984Z",
    fill: "#FF7816"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPending, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Pending.d7890349.svg";
export { ForwardRef as ReactComponent };